import axios from "axios";

export const aboutData = () => {
    return axios
      .get("/page/about us")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };